import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_InvalidRuntimeFinding } from '@app/advisor-shared';
import { BadImplementationException, deepClone } from '@nu-art/ts-common';
import { ModuleFE_EncounterMetadata, sendValidateCacheMessage } from '../../../index.js';
import { ModuleFE_BaseAdvisorRuntime } from '../../../modules/ModuleFE_BaseAdvisorRuntime.js';
import { ModuleFE_AdvisorSession } from '../../advisor-session/index.js';
export const dispatch_onInvalidRuntimeFindingsUpdated = new ThunderDispatcherV3('__onInvalidRuntimeFindingsUpdated');
export class ModuleFE_InvalidRuntimeFinding_Class extends ModuleFE_BaseAdvisorRuntime {
    __validateCache() {
        const patientId = ModuleFE_AdvisorSession.getCurrentPatientId();
        if (!patientId)
            return;
        const irrelevantInvalidFindings = this.cache.filter(finding => finding.patientId !== patientId);
        const moduleName = this.getName();
        if (!irrelevantInvalidFindings.length)
            return this.logDebug(`${moduleName} cache is valid`);
        this.logErrorBold(`${moduleName} has invalid data in cache`, irrelevantInvalidFindings);
        return sendValidateCacheMessage(irrelevantInvalidFindings, moduleName);
    }
    constructor() {
        super(DBDef_InvalidRuntimeFinding, dispatch_onInvalidRuntimeFindingsUpdated);
        const originalAllMutable = this.cache.allMutable;
        // @ts-ignore
        this.cache.allMutable = () => {
            return originalAllMutable().map(item => {
                // @ts-ignore
                const _newFinding = deepClone(item);
                _newFinding.invalid = true;
                return _newFinding;
            });
        };
    }
    init() {
        super.init();
        this.setCacheFilter(ModuleFE_AdvisorSession.patientFilter);
    }
    async clearEncounterDataFromIDB(encounterId) {
        const patientEncounter = await ModuleFE_EncounterMetadata.IDB.unique(encounterId);
        if (!patientEncounter)
            throw new BadImplementationException('Failed to get patientEncounter to clean from IDB');
        const IDBDataToDelete = await this.IDB.filter(finding => finding.patientId === patientEncounter.patientId);
        await this.IDB.storeWrapper.deleteAll(IDBDataToDelete);
    }
}
export const ModuleFE_InvalidRuntimeFinding = new ModuleFE_InvalidRuntimeFinding_Class();
//# sourceMappingURL=ModuleFE_InvalidRuntimeFinding.js.map